export default __webpack_public_path__ + "static/media/sx.b6d0db02.svg";